<div class="row">
  <div class="col-md-12 col-lg-6">
    <nb-card>
      <nb-card-body>
        <h6>{{ 'info.kontakt.siedziba' | translate }}</h6>
                
        <div>
          <div><strong>{{ 'info.kontakt.adres' | translate }}</strong></div>
          <div>ul. Jaśkowa Dolina 6/3</div>
          <div>80-252 Gdańsk</div>
        </div>
        <br />

        <div>
          <a href="https://www.dwaplusjeden.com">www.dwaplusjeden.com</a>
        </div>
        <br />

        <h6>{{ 'info.kontakt.kontakt' | translate }}</h6>
        <div>
          <div><strong>{{ 'info.kontakt.obsluga-klienta' | translate }}</strong></div>
          <div>tel. <a href="tel:+48797480922">+48 797 480 922</a></div>
          <div><a href="mailto:bok@dwaplusjeden.com">bok@dwaplusjeden.com</a></div>
        </div>
        <br />
        <div>
          <div><strong>{{ 'info.kontakt.doradca-biznesowy' | translate }}</strong></div>
          <div>tel. <a href="tel:+48784955666">+48 784 955 666</a></div>
          <div><a href="mailto:kontakt@dwaplusjeden.com">kontakt@dwaplusjeden.com</a></div>
        </div>
        <br />
        <div>
          <div><strong>{{ 'info.kontakt.obsluga-platnosci' | translate }}</strong></div>
          <div><a href="mailto:dzialplatnosci&#64;dwaplusjeden.com">dzialplatnosci&#64;dwaplusjeden.com</a></div>
        </div>
        <br />
        <div>
          <div><strong>{{ 'info.kontakt.godziny-pracy-etykieta' | translate }}</strong></div>
          <div>{{ 'info.kontakt.godziny-pracy' | translate }}</div>
        </div>
        <br />
        <div>
          <div><strong>{{ 'info.kontakt.konto-bankowe' | translate }}</strong></div>
          <div>BNP Paribas Bank Polska S.A.</div>
          <div>68175000120000000013837578</div>
        </div>
      </nb-card-body>
    </nb-card>
  </div>

  <div class="col-md-12 col-lg-6">
    <nb-card>
      <nb-card-body>       
        <ngx-wiadomosc></ngx-wiadomosc>
      </nb-card-body>
    </nb-card>
  </div>
</div>
